import React from 'react';

interface TripHotelCardStatsProps {
  stars?: number;
  promotionsCount?: number;
}

export default function TripHotelCardStats({
  stars,
  promotionsCount,
}: TripHotelCardStatsProps) {
  return (
    <div className="shrink-0">
      <div className="flex space-x-1 justify-end">
        <svg
          className="text-yellow-500 w-5 h-5"
          fill="currentColor"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
          />
        </svg>
        <div className="text-sm">{stars ?? 0}</div>
      </div>

      {promotionsCount !== undefined && (
        <div className="mt-0.5 flex space-x-1 justify-end">
          <svg
            className={`${
              promotionsCount ? 'text-green-500' : 'text-gray-200'
            } h-5 w-5`}
            fill="currentColor"
            viewBox="0 0 448 512"
          >
            <path d="M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 96c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z" />
          </svg>
          <div className="text-sm">{promotionsCount}</div>
        </div>
      )}
    </div>
  );
}
